import { use, useEffect } from 'react';
import { LocalStorageKey } from '../data/client_local_storage.ts';
import { useLocalStorage } from '../data/use_local_storage.tsx';
import { holdScreenWakeLock } from '../util/screen_wake_lock.ts';
import { SequencerContext } from './sequencer.tsx';

// Holds the screen awake while a song is loaded in the player and the "Keep Screen Awake" song
// option is on (issue #3608). "Loaded" rather than "playing" on purpose: the stalls this works
// around hit when the phone locks between verses or between songs, while nothing is playing, so
// the hold lasts as long as the song is in the player, full or mini. The browser drops the lock
// whenever the page is hidden, so a backgrounded app still lets the phone sleep.
export function useKeepScreenAwake(): void {
  const [keepScreenAwake] = useLocalStorage(LocalStorageKey.KeepScreenAwake);
  const { hymn } = use(SequencerContext);
  const wanted = keepScreenAwake && hymn !== undefined;

  useEffect(() => {
    if (!wanted) {
      return;
    }
    return holdScreenWakeLock();
  }, [wanted]);
}
